var scope_0 = require('/Users/ben/workspaces/datalab-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/Users/ben/workspaces/datalab-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4b1eceba4093ecc1f2c8741c2e2a9ac6.js').default;
var scope_2 = require('/Users/ben/workspaces/datalab-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a808781e84e7fada9ea7d25b4ce7e709.js').default;
var scope_3 = require('/Users/ben/workspaces/datalab-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b0ce913666be7e6bceb9808bae9f76c1.js').default;
var scope_4 = require('/Users/ben/workspaces/datalab-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8e60223d62725a9c28f1ff263ea1f33.js').default;
var scope_5 = require('/Users/ben/workspaces/datalab-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c57e3b868bd6a28245fd7962dbe095e1.js').default;
var scope_6 = require('/Users/ben/workspaces/datalab-blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fae58192727fee9b95c1926b9892cc10.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    